import Vue from 'vue'


Vue.component('CaseStudyListItem', {
  template: '#case-study-list-item',
  props: ['link', 'summary']
})